import { createSlice } from '@reduxjs/toolkit';

export const CesantiasSlice = createSlice({
    name: 'cesantias',
    initialState: {
        cesantias_list: [],
        cesantias_list_select: []
    },
    reducers: {
        setCesantiasRedux: ( state, { payload } ) => {
            state.cesantias_list  =  payload;
        },
        setCesantiasSelectRedux: ( state, { payload } ) => {
            state.cesantias_list_select  =  payload;
        },
        
    }
});


// Action creators are generated for each case reducer function
export const { setCesantiasRedux, setCesantiasSelectRedux } = CesantiasSlice.actions;